import Seo from "@/components/feature/Seo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import EditorPicks from "@/pages/home/components/EditorPicks";
import LatestHotSection from "@/pages/home/components/LatestHotSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <>
      <Seo
        title="肮脏的交易-影视作品资讯与剧情解析"
        description="肮脏的交易官网，提供最新影视作品资讯、详细剧情介绍和角色分析，满足您对影视内容的多样需求。"
        keywords="肮脏的交易,影视作品,剧情介绍,影视资讯,电影推荐,剧情解析,影视分析"
      />
      <HeroCarousel />
      <CategoryEntries />
      <EditorPicks />
      <LatestHotSection />
      <SiteIntro />
    </>
  );
}